import React, { useState } from 'react';
import { safeFetch } from '../../App';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Textarea } from '../ui/Input';

/**
 * Owner-only modal: composes and broadcasts a push notification to followers
 * of the business. Owns the message state internally so the parent doesn't
 * have to.
 */
export function BusinessPushNotificationModal({ isOpen, onClose, business, chatId }) {
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);

    const handleSend = async () => {
        if (!message.trim()) return;
        setSending(true);
        try {
            const res = await safeFetch(
                'https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/send-business-push-notification',
                chatId,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        business_id: business.business_id,
                        business_name: business.business_name,
                        chat_id: chatId,
                        message,
                    }),
                },
            );
            if (!res.ok) throw new Error('Failed to send notification');
            onClose();
            setMessage('');
        } catch (err) {
            console.error('❌ Failed to send notification:', err);
            alert('שגיאה בשליחת הודעה');
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="sm"
            title="שלח עדכון לכל העוקבים"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose} disabled={sending}>ביטול</Button>
                    <Button variant="primary" onClick={handleSend} loading={sending} disabled={!message.trim()}>
                        שלח הודעה
                    </Button>
                </>
            }
        >
            <Textarea
                rows={4}
                placeholder="הקלידו את ההודעה..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            />
        </Modal>
    );
}

export default BusinessPushNotificationModal;
